import React, { Component } from 'react'
import './index.scss'
import { Tabs } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

export class index extends Component {
  static defaultProps = {
    titleIshow: true
  }

  state = {
    num: 0,
    page: 1,

    items: [
      {
        name: '工业',
        image: require('../../../image/工业.png'),
        selectimage: require('../../../image/icon工业-圆.png'),
        style: { width: '1.714286rem', height: '1.714286rem' },
        children: [
          { title: '数据可视化平台', text: '助力企业和政府进行数字化转型，多样化的数据源集成，丰富的主题组件，便捷的可视化设计，实现全网数据的集约化汇聚。', image: require('../../../image/数据可视化平台.png'), to: '/product/solution/3.html' },
          { title: 'RFID生产线管理系统解决方案', text: '通过采用RFID技术，系统能够自动采集生产数据和设备状态数据，为生产管理者提供生产线所有工序环节的“实时数据”。', image: require('../../../image/RFID生产线管理系统解决方案.png') },
          { title: '机房监控解决方案', text: '在大数据时代背景下让传统能源系统实现高效快捷的管理, 降低架构扩容成本、增强可扩展性、应用处理的简单化。', image: require('../../../image/机房监控解决方案.png') },
          { title: '厂区安全生产综合管理解决方案', text: '系统基于现有物联网技术、移动互联网技术，为用户提供智能化、移动化、一体化的安全生产综合监测系统，帮助企业用户建立一套完善的安全生产体系。', image: require('../../../image/厂区安全生产综合管理解决方案.png'), to: '/product/solution/2.html' },
          { title: '工业物联网远距离通信RT-Chirp', text: 'RT-Chirp使用双通道方案。竞争性信道采用CSMA/CA技术，满足入网、资源请求和告警数据的实时传输需求。', image: require('../../../image/工业物联网远距离通信RT-Chirp.png') },
          { title: '工业物联网边缘计算及响应方案', text: '该产品可以在现场独立部署，也可以与工业物联网数据服务平台协同工作，构建一个完整的工业物联网网络。', image: require('../../../image/工业物联网边缘计算及响应方案.png') },
          { title: '数据化可视平台', text: '助力企业数字化管理', image: require('../../../image/s1.png') },
          { title: '智能井盖解决方案', text: '物联网领域、新视野', image: require('../../../image/s2.png') },
          { title: '厂区安全生产监测方案', text: '作业区危险行为监测', image: require('../../../image/s3.png'), to: '/product/solution/4.html' }
        ]
      },
      {
        name: '能源',
        image: require('../../../image/icon能源-蓝@2x.png'),
        selectimage: require('../../../image/能源蓝.png'),
        style: { width: '1.271429rem', height: '1.571429rem' },
        children: [
          { title: '智能远传系统在储罐/槽车监测方案', text: '内嵌GIS模块，支持卫星地图，可在地图上显示监测设备分布情况并准确定位，满足客户本地和远程的监控需求。', image: require('../../../image/智能远传系统在储罐槽车监测方案.png') },
          { title: '综合管廊/天然气站可燃气监测方案', text: '采用激光气体监测设备，响应时间≤2s，质保按5年寿命计算，免维护，无需标定，节省大量的人力、物力、时间成本。不受其它环境因素干扰。', image: require('../../../image/综合管廊天然气站可燃气监测方案.png') },
          { title: '石油储罐在线监测解决方案', text: '石油储罐在线监测系统可将石油储罐安全防护工作由人防转为技防，同时还降低了工作人员的防护劳动强度，将传统的事后灭火抢险转换为事前主动预防。', image: require('../../../image/石油储罐在线监测解决方案.png') },
          { title: '天然气长输管道泄露激光监测方案', text: '基于可调谐半导体激光吸收光谱 （TDLAS） 技术的激光泄汽检测系统的应用，则可以满足长距离天然气隧道可燃气体泄漏检测的需要。', image: require('../../../image/天然气长输管道泄露激光监测方案.png') },
          { title: '餐饮行业天然气泄漏监测方案', text: '在检测到气体泄漏浓度达到低限报警时发出声光报警，提醒工作人员及时检查维修，在检测到气体泄漏浓度达到高限报警时给自动切断阀发出控制信号。', image: require('../../../image/餐饮行业天然气泄漏监测方案.png') },
          { title: '电力系统综合监控解决方案', text: '该安全防范子系统的各种探测器将与视频监控子系统中的视频设备连接。在发生触发报警的情况下，直接和视频设备联动，将报警信息上传至综合监控平台。', image: require('../../../image/电力系统综合监控解决方案.png') },
          { title: '智能远传系统在储罐/槽车监测方案', text: '作业区危险行为监测', image: require('../../../image/s3.png') },
          { title: '智能井盖解决方案', text: '物联网领域、新视野', image: require('../../../image/s2.png') },
          { title: '数据化可视平台', text: '助力企业数字化管理', image: require('../../../image/s1.png') }
        ]
      },
      {
        name: '市政',
        image: require('../../../image/icon市政-蓝@2x.png'),
        selectimage: require('../../../image/市政.png'),
        style: { width: '1.542857rem ', height: '1.571429rem' },

        children: [
          { title: '智慧城市综合管控平台解决方案', text: '实现将城市运行核心系统的各项关键数据进行呈现，从而对包括应急指挥、城市管理、公共安全、环境保护、智能交通、基础设施等领域进行管理决策支持。', image: require('../../../image/智慧城市综合管控平台解决方案.png') },
          { title: '智能井盖监管综合解决方案', text: '可应用于城市中多个方面：管廊、隧道、各类电缆沟、污水井、检修口等人员出入的地下工程项目，在用的各类窨井盖均可升级为智能井盖。', image: require('../../../image/智能井盖监管综合解决方案.png'), to: '/product/solution/1.html' },
          { title: '智慧安防应用平台建设方案', text: '平台以三维空间引擎为基础，对大量空间基础地理信息数据及业务数据进行分层提炼、挖掘、整合、分析，为决策者提供全方位、宏观、综合管理服务。', image: require('../../../image/智慧安防应用平台建设方案.png') },
          { title: '智慧管廊综合监控及运维管理方案', text: '基于“物联网、云计算、大数据、3S、BIM”等技术，实现了管廊全生命周期各参与方在同一平台上分布式数据采集、大数据分析、监控运维等所有应用服务。', image: require('../../../image/智慧管廊综合监控及运维管理方案.png') },
          { title: '智慧社区解决方案', text: '智慧安防实现社区视频覆盖，智慧出行人员无痛感通行，访客、车辆通行，智慧充电以服务驱动电动车根源整治，提升社区市容环境，多维度关注老人生活。', image: require('../../../image/智慧社区解决方案.png') },
          { title: '智慧园区综合管理解决方案', text: '智慧园区综合管理平台是利用标准化的通讯接口将各个子系统联接起来并通过统一的平台实现建筑物设备的自动检测与优化控制。', image: require('../../../image/智慧园区综合管理解决方案.png') },
          { title: '智能远传系统在储罐/槽车监测方案', text: '作业区危险行为监测', image: require('../../../image/s3.png') },
          { title: '数据化可视平台', text: '助力企业数字化管理', image: require('../../../image/s1.png') }
        ]
      },
      {
        name: '医疗',
        image: require('../../../image/icon医疗-蓝@2x.png'),
        selectimage: require('../../../image/医疗.png'),
        style: { width: '1.362857rem ', height: ' 1.428571rem ' },

        children: [
          { title: '医用气体系统运行监测解决方案', text: '应用于对医院医用气体供应系统的运行监测管理，通过对各子系统的设备及管路进行实时数据监测，实现对医疗机构医用气体系统的全系统运行监测。', image: require('../../../image/医用气体系统运行监测解决方案.png') },
          { title: '医院气源站点区域环境监测方案', text: '在气源站点区域加装数据传感器、环境监测传感器等设备，有效对区域内人员活动情况、环境气体浓度、烟雾、通风、水浸等进行全天24小时不间断监测。', image: require('../../../image/医院气源站点区域环境监测方案.png') },
          { title: '医院智慧护理系统解决方案', text: '病房智能整体解决方案，实现精细化护理，优化护理流程，提高护理质量和效率，帮助护理人员获取护理大数据，推进护理学科的发展。', image: require('../../../image/医院智慧护理系统解决方案.png') },
          { title: '医院能源与设备运维信息化管理', text: '能源与设备运维信息管理系统通过能源精细化管理与信息共享，可以提升医院后勤运维管理水平，确保用能安全。', image: require('../../../image/医院能源与设备运维信息化管理.png') }
        ]
      },
      {
        name: '水务',
        image: require('../../../image/icon水务-蓝@2x.png'),
        selectimage: require('../../../image/水务.png'),
        style: { width: '1.4rem ', height: '1.142857rem ' },

        children: [
          { title: '水库坝区监测预警系统', text: '整合物联网技术、传感器技术、无线传输技术和数据分析统计技术，通过结构环境监测传感器对坝体、坝肩、坝区岸坡等多项安全数据进行实时自动测量。', image: require('../../../image/水库坝区监测预警系统.png') },
          { title: '污水处理运行监测解决方案', text: '本系统大大方便了管理人员对分布在不同地域的污水处理系统的管理和维护，可在第一时间获取现场异常信息，提高了维护管理效率。', image: require('../../../image/污水处理运行监测解决方案.png') },
          { title: '水质在线监测系统', text: '水质在线监测系统用于实时监测湖泊、水库、饮用水源地、地下水观测点等水质变化状况，系统融合了水质环境监测、异常数据预警等功能。', image: require('../../../image/水质在线监测系统.png') }
        ]
      },
      {
        name: '建筑',
        image: require('../../../image/智慧圆区.png'),
        selectimage: require('../../../image/建筑.png'),
        style: { width: '1.485714rem ', height: '1.485714rem' },

        children: [
          { title: '实验室安全监测解决方案', text: '针对不同类型实验室监控需求不尽相同的特点，通过运用物联网信息技术，使其在应用中的适用性更强，操作更便捷，监测项更全面。', image: require('../../../image/实验室安全监测解决方案.png') },
          { title: '塔机安全监控管理系统', text: '通过前端监控装置和平台无缝对接，将塔机运行数据和报警信息实时发送到远程GIS可视化监控平台，实现数据分析反馈，辅助驾驶员安全规范操作。', image: require('../../../image/塔机安全监控管理系统.png') },
          { title: '智慧（数字化）示范工地解决方案', text: '利用移动互联、物联网、云计算、大数据等新一代信息技术，彻底改变传统建筑施工现场参建各方现场管理的交互方式、工作方式和管理模式。', image: require('../../../image/智慧（数字化）示范工地解决方案.png') },
          { title: '装配式建筑协同管理平台解决方案', text: '基于BIM开发的装配式建筑协同管理系统，可用于装配式建筑的设计、构件加工、施工全过程。采用相应的编码系统对BIM模型信息进行轻量化。', image: require('../../../image/装配式建筑协同管理平台解决方案.png') },
          { title: '桥梁结构监测系统解决方案', text: '监测桥梁运营阶段各监测指标参数数值、变化趋势，通过合理的计算和分析对桥梁工作状态进行评估和预报，以确保桥梁管理者随时了解桥梁的安全状况。', image: require('../../../image/桥梁结构监测系统解决方案.png') }
        ]
      },
      {
        name: '农业',
        image: require('../../../image/icon农业-蓝@2x.png'),
        selectimage: require('../../../image/农业.png'),
        style: { width: '1.357143rem ', height: '1.428571rem' },

        children: [
          { title: '智慧农业大棚数据监测系统', text: '可以实时采集农业大棚内空气温度、湿度、光照、土壤温度、土壤水分、二氧化碳等环境参数，根据农作物生长需要进行实时智能决策，自动开启或者关闭。', image: require('../../../image/智慧农业大棚数据监测系统.png') },
          { title: '智慧无线自动灌溉系统解决方案', text: '精准灌溉和施肥集成的水肥一体化技术，将使肥料随适量的灌水进入作物根系附近，不会在深层流失，既满足了作物生长所需的水肥，提高了水肥利用率。', image: require('../../../image/智慧无线自动灌溉系统解决方案.png') },
          { title: '农产品溯源专业解决方案', text: '当终端消费者购买了贴有二维码标签的农产品后，只需使用手机扫码即可查询产品的详细信息，实现产品的来源可查，去向可追，责任可究。 ', image: require('../../../image/农产品溯源专业解决方案.png') }
        ]
      }
    ],
    select: 0,
    children: [],
    myChildren: []
  }
  componentWillMount() {
    const { items, select } = this.state
    this.setState({ children: items[select].children })
    this.selectFn(0)
  }
  selectFn = (index) => {
    const { items } = this.state
    const arr = items[index].children
    let itemarr = []
    let pushitem = []
    let num = 0
    arr.forEach((item, index) => {
      num++
      pushitem.push(item)
      if (num == 6) {
        itemarr.push(pushitem)
        pushitem = []
        num = 0
      } else if (arr.length == index + 1) {
        itemarr.push(pushitem)
        pushitem = []
        num = 0
      }
    })

    this.setState({ select: index, children: items[index].children, myChildren: itemarr, num: 0 })
  }
  upPage = () => {
    this.setState({ num: this.state.num + 1 })
  }
  render() {
    const { items, select, children, num, myChildren } = this.state

    return (
      <div className="typeArea Hardware">
        {this.props.titleIshow && (
          <div className="Hardware-title">
            <div className="Hardware-title-h1">解决方案</div>
            <div className="Hardware-title-text">SOLUTION</div>
          </div>
        )}

        <div className="Hardware-my-content">
          <div className="Hardware-my-content-top" style={{ display: 'flex', width: '39.828571rem', justifyContent: 'space-between', borderBottom: '1px solid #D3D3D3' }}>
            {items.map((item, index) => (
              <div className={`seletItem ${select == index ? 'borderbottom' : ''}`} key={index} onMouseEnter={() => this.selectFn(index)} style={{ borderBottom: `` }}>
                <div className="Hardware-my-select-box">{index == select ? <img className="seletItem-img" src={item.selectimage} alt="" /> : <img className="seletItem-img" src={item.image} alt="" style={item.style} />}</div>
                <div className="seletItem-text" style={{ color: `${select == index ? '#2176D0' : '#333333'}` }}>
                  {item.name}
                </div>
              </div>
            ))}
          </div>
          {children.length < 6 && (
            <div className="my-content">
              {children.map((item, index) => (
                <div className="my-content-item myhover" key={index} style={{ marginRight: `${(index + 1) % 3 == 0 ? '0px' : '0.5rem'}` }}>
                  <div className="my-content-item-imagebox">
                    <img src={item.image} className="my-content-item-img" alt="" />
                  </div>
                  <div className="my-content-item-details ">
                    <div className="my-content-item-details-texttitle">{item.title}</div>
                    <div className="my-content-item-details-text-content">{item.text}</div>
                    <div className="my-content-item-details-button">
                      了解更多 <ArrowRightOutlined style={{ fontSize: '.457143rem', marginLeft: '.285714rem' }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {children.length > 6 && (
            <div className="my-content">
              {myChildren[num].map((item, index) => (
                <div className="my-content-item myhover" key={index} style={{ marginRight: `${(index + 1) % 3 == 0 ? '0px' : '0.5rem'}` }}>
                  <div className="my-content-item-imagebox">
                    <img src={item.image} className="my-content-item-img" alt="" />
                  </div>
                  {item.to ? (
                    <Link to={item.to}>
                      <div className="my-content-item-details ">
                        <div className="my-content-item-details-texttitle">{item.title}</div>
                        <div className="my-content-item-details-text-content">{item.text}</div>

                        <div className="my-content-item-details-button">
                          了解更多 <ArrowRightOutlined style={{ fontSize: '.457143rem', marginLeft: '.285714rem' }} />
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <div className="my-content-item-details ">
                      <div className="my-content-item-details-texttitle">{item.title}</div>
                      <div className="my-content-item-details-text-content">{item.text}</div>

                      <div className="my-content-item-details-button">
                        了解更多 <ArrowRightOutlined style={{ fontSize: '.457143rem', marginLeft: '.285714rem' }} />
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {children.length > 6 && (
          <div className="cooperation-content-pages" style={{ marginTop: '.885714rem' }}>
            <div className="cooperation-content-pages-button" style={{ marginRight: '0.4rem' }} onClick={() => (num != 0 ? this.setState({ num: num - 1 }) : '')}>
              上一页
            </div>
            {myChildren.map((i, index) => (
              <div key={index} className={`cooperation-content-pages-button-text ${index == num ? 'btnbgc' : ''}`} onClick={() => this.setState({ num: index })}>
                {index + 1}
              </div>
            ))}
            <div className="cooperation-content-pages-button" onClick={() => (num + 1 < myChildren.length ? this.setState({ num: num + 1 }) : '')}>
              下一页
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default index
